import { observable, action, computed, autorun } from "mobx";

import { BaseStore, Delay } from "./BaseStore";
import { ConfigurationEndpoints } from "../endpoints/ConfigurationEndpoints";

import { AllConfiguration } from "../model/Configuration";
import { Country, Province } from "../model/Address";
import { Horse, HorseColour, HorseGait, HorseSex } from "../model/Horse";
import { HorseSale, StakeEngagement } from "../model/HorseForSale";
import { Role, RoleListBuilder } from "../model/Role";
import { CustomerIdentificationType, InsuranceCompany } from "../model/Customer";
import { EntryType, SalesTax } from "src/model/Financial";

export class ConfigurationStore extends BaseStore {
    @observable private _configuration: AllConfiguration | null = null;

    constructor(private configurationEndpoints: ConfigurationEndpoints) {
        super();
    }

    @action async refresh(): Promise<AllConfiguration> {
        this.setLoading();
        try {
            this._configuration = await this.configurationEndpoints.getConfiguration();
            return this._configuration;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    findHorseSaleById(id: number): HorseSale | null {
        return this.horseSales.find(h => h.id === id) || null;
    }

    findHorseGaitById(id: number): HorseGait | null {
        return this.horsesGaits.find(g => g.id === id) || null;
    }

    @computed get roles(): Array<Role> {
        return RoleListBuilder();
    }

    @computed get countries(): Array<Country> {
        return this._configuration ? this._configuration.countries : [];
    }

    @computed get provinces(): Array<Province> {
        return this._configuration ? this._configuration.provinces : [];
    }

    @computed get horseSales(): Array<HorseSale> {
        return this._configuration ? this._configuration.horseSales : [];
    }

    @computed get identifiationTypes(): Array<CustomerIdentificationType> {
        return this._configuration ? this._configuration.identificationTypes : [];
    }

    @computed get horsesSexes(): Array<HorseSex> {
        return this._configuration ? this._configuration.horseSexes : [];
    }

    @computed get horsesGaits(): Array<HorseGait> {
        return this._configuration ? this._configuration.horseGaits : [];
    }

    @computed get horsesColours(): Array<HorseColour> {
        return this._configuration ? this._configuration.horseColours : [];
    }

    @computed get stakeEngagements(): Array<StakeEngagement> {
        return this._configuration ? this._configuration.stakeEngagements : [];
    }

    @computed get insuranceCompanies(): Array<InsuranceCompany> {
        return this._configuration ? this._configuration.insuranceCompanies : [];
    }

    @computed get entryTypes(): Array<EntryType> {
        return this._configuration ? this._configuration.entryTypes : [];
    }

    @computed get salesTaxes(): Array<SalesTax> {
        return this._configuration ? this._configuration.salesTaxes : [];
    }

    findEntryTypeById(id: number | null): EntryType | undefined {
        return this.entryTypes.find(e => e.id === id);
    }

    findEntryDebitCreditById(id: number | null): "DEBIT" | "CREDIT" | undefined {
        const entry = this.findEntryTypeById(id);
        return entry ? entry.debitCredit : undefined;
    }
}



// WEBPACK FOOTER //
// ./src/stores/ConfigurationStore.ts